import styled from "styled-components";

export const Container = styled.section`
    max-width: 1280px;
    margin: 4rem auto;
    padding: 0 2rem;
    text-align: center;
`;

export const Title = styled.h2`
    color: #130c63;
    font-weight: bold;
    text-transform: uppercase;
    font-size: 22px;
    margin-bottom: 2rem;
`;

export const CardsWrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 1.5rem;
`;

export const Card = styled.div`
    background-color: #f9e9b3;
    border-radius: 16px;
    flex: 1 1 calc(33.333% - 1.5rem); 
    max-width: 360px;
    min-height: 250px;
    padding: 1.5rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);

    @media (max-width: 1024px) {
        flex: 1 1 calc(45% - 1.5rem); 
    }

    @media (max-width: 768px) {
        flex: 1 1 100%;
        width: 90%;
    }
`;

export const CardContent = styled.div`
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    text-align: center;
`;

export const Text = styled.p`
    color: #555;
    font-size: 16px;
    margin-bottom: 1rem;
    text-align: justify;
`;

export const AuthorBox = styled.div`
    margin-top: 1rem;
`;

export const AuthorName = styled.h4`
    font-weight: bold;
    font-size: 14px;
    color: #000;
    margin-bottom: 0.3rem;
`;

export const AuthorRole = styled.p`
    font-size: 14px;
    color: #5b5957;
    font-weight: 500;
`;

export const Stars = styled.img`
    width: 120px;
    height: auto;
    margin-top: 1rem;
`;

export const Button = styled.a`
    display: inline-block;
    background-color: #f3cc3b;
    color: #170c66;
    padding: 16px 24px;
    border-radius: 12px;
    font-weight: bold;
    text-decoration: none;
    font-size: 16px;
    cursor: pointer;
    margin-top: 2rem;
    transition: background-color 0.3s ease;

    &:hover {
        background-color: #fede68;
    }
`;
